import { Box, Stack } from "@mui/material";
import CarouselCard from "Components/UI/CarouselCard";
import StandardAnalyticsCard from "features/analytics/components/StandardAnalyticsCard";
import { StandardAnalyticsChartStatCard } from "features/analytics";
import {
  CHART_KEY_DASHBOARD_NEW_RETURNING_NEW_CUSTOMERS,
  CHART_KEY_DASHBOARD_NEW_RETURNING_REPEAT_CUSTOMERS,
  CHART_KEY_DASHBOARD_NEW_RETURNING_REPEAT_RATE,
  CHART_KEY_DASHBOARD_NEW_RETURNING_REPEAT_REVENUE,
  CHART_KEY_DASHBOARD_NEW_RETURNING_REVENUE_TREND,
} from "features/analytics/constants/chartKeys";
import { StoreCustomersPieChart } from "Pages/Analyse/StoreOverview/StoreOverviewPieCharts";
import {
  ApiChartAttribute,
  ApiChartTemplate,
  ApiChartType,
  ApiDimension,
  ApiMetric,
} from "@incendium/api";

interface INewReturningTabProps {
  attributes: ApiChartAttribute[];
}

function NewReturningTab({ attributes }: INewReturningTabProps) {
  return (
    <>
      <CarouselCard
        title="Key Stats"
        emptyMessage="No key stats available"
        items={[
          <StandardAnalyticsChartStatCard
            chartKey={CHART_KEY_DASHBOARD_NEW_RETURNING_NEW_CUSTOMERS}
            staticAttributes={attributes}
            chart={{
              name: "New Customers",
              dimension: [ApiDimension.DIMENSION_NOT_SET],
              template: ApiChartTemplate.SNAPSHOT,
              type: ApiChartType.STAT_CARD,
              attributes: [],
              yAxisKeys: [
                {
                  key: "l",
                  fields: [ApiMetric.METRIC_NEW_CUSTOMERS_COUNT],
                },
              ],
              displayOptions: {
                statTitle: "New Customers",
              },
              comparison: true,
            }}
          />,
          <StandardAnalyticsChartStatCard
            chartKey={CHART_KEY_DASHBOARD_NEW_RETURNING_REPEAT_CUSTOMERS}
            staticAttributes={attributes}
            chart={{
              name: "Repeat Customers",
              dimension: [ApiDimension.DIMENSION_NOT_SET],
              template: ApiChartTemplate.SNAPSHOT,
              type: ApiChartType.STAT_CARD,
              attributes: [],
              yAxisKeys: [
                {
                  key: "l",
                  fields: [ApiMetric.METRIC_REPEAT_CUSTOMERS_COUNT],
                },
              ],
              displayOptions: {
                statTitle: "Repeat Customers",
              },
              comparison: true,
            }}
          />,
          <StandardAnalyticsChartStatCard
            chartKey={CHART_KEY_DASHBOARD_NEW_RETURNING_REPEAT_RATE}
            staticAttributes={attributes}
            chart={{
              name: "Repeat Customer Rate",
              dimension: [ApiDimension.DIMENSION_NOT_SET],
              template: ApiChartTemplate.SNAPSHOT,
              type: ApiChartType.STAT_CARD,
              attributes: [],
              yAxisKeys: [
                {
                  key: "l",
                  fields: [ApiMetric.METRIC_REPEAT_CUSTOMER_RATE],
                },
              ],
              displayOptions: {
                statTitle: "Repeat Customer Rate",
              },
              comparison: true,
            }}
          />,
          <StandardAnalyticsChartStatCard
            chartKey={CHART_KEY_DASHBOARD_NEW_RETURNING_REPEAT_REVENUE}
            staticAttributes={attributes}
            chart={{
              name: "Repeat Customer Revenue",
              dimension: [ApiDimension.DIMENSION_NOT_SET],
              template: ApiChartTemplate.SNAPSHOT,
              type: ApiChartType.STAT_CARD,
              attributes: [],
              yAxisKeys: [
                {
                  key: "l",
                  fields: [ApiMetric.METRIC_REPEAT_CUSTOMERS_REVENUE],
                },
              ],
              displayOptions: {
                statTitle: "Repeat Customer Revenue",
              },
              comparison: true,
            }}
          />,
        ]}
        loading={false}
      />

      <Stack
        direction={{ xs: "column", md: "row" }}
        spacing={2}
        sx={{ flexShrink: 0, width: "100%" }}
      >
        <Box
          sx={{
            height: 400,
            width: { xs: "100%", md: "33.333%" },
            flexShrink: 0,
          }}
        >
          <StoreCustomersPieChart />
        </Box>

        <Box sx={{ height: 400, flex: 1, minWidth: 0 }}>
          <StandardAnalyticsCard
            chartKey={CHART_KEY_DASHBOARD_NEW_RETURNING_REVENUE_TREND}
            staticAttributes={attributes}
            ignoreAttrModel
            chart={{
              name: "Revenue by Customer Type",
              dimension: [
                ApiDimension.DIMENSION_SESSION_START_BY_DAY,
                ApiDimension.DIMENSION_CUSTOMER_TYPE,
              ],
              template: ApiChartTemplate.TREND,
              type: ApiChartType.GRAPH,
              attributes: [],
              yAxisKeys: [
                {
                  key: "l",
                  fields: [ApiMetric.METRIC_REVENUE],
                },
              ],
              displayOptions: {
                noFilters: true,
              },
            }}
          />
        </Box>
      </Stack>
    </>
  );
}

export default NewReturningTab;
